module.exports = __webpack_public_path__ + "static/media/did-you-know-arrow-right.d091606a.svg";